<template>
    
    <div class="temp-wrap" >
        <div class="main-title">
            <h1 v-html="all_questions.questions_act.title"></h1>
        
        </div>
        <div class="bottom-list-wrap" >
            <ul class="custom-scroller">
                
                <li class="qa-li" v-for="q in all_questions.questions_act.questions">
                    <div class="qa-div q">
                        <div class="char">Q :</div>
                        <div class="text">{{q.q}}</div>
                    </div>
                    <div class="qa-div">
                        <div class="char">A :</div>
                        <div class="text">{{q.a}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

import ct_scroll from './function.js'

export default {
    props: ["all_questions"],
    mounted(){
        ct_scroll();
    }

}
</script>



// WEBPACK FOOTER //
// src/Qna/act.vue